<template>
    <!-- 弹出窗口 -->
    <div class="pos-a zindex-999 right-10 top-40 bg-hei-05 cr-white pd-30 all-an" :class="mob ? 'wd-90p' : 'wd-500'"
        v-if="show && pInfo">
        <div class="pos-a zindex-99 top-0 right-0 wd-40 ht-40 bg-hei-05 dp-flex jus-c cr-hui pointer" @click="colse()">
            <Icon type="md-close" :class="mob ? 'font-50' : 'font-30'" />
        </div>
        <div class="font-16 pd-t-10 ht-50vh ov-a-y" v-html="pInfo"></div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        pInfo: {},
        show: false,
    },
    data() {
        return {
        };
    },
    methods: {
        colse() {
            this.$emit("textBoxShow", false);
        },
    },
    created() {
    },
    computed: {
        mob() {
            return this.$store.state.mob;
        }
    },
    watch: {
    },
    beforeDestroy() { },
};
</script>